import FormItem from './FormItem'
import Icon from './Icon'
import { BreadcrumbActivityMetaItem } from './BreadcrumbActivityBox'

interface EventCommentActivityBoxProps {
  title: string
  variant: 'comment' | 'like'
  content?: string
  meta: BreadcrumbActivityMetaItem[]
  onDelete?: () => void
}

const EventCommentActivityBox = ({ title, variant, content, meta, onDelete }: EventCommentActivityBoxProps) => {
  return (
    <div className={`breadcrumb-activity-box breadcrumb-activity-box--${variant === 'comment' ? 'breadcrumb' : 'reply'}`}>
      <div className="breadcrumb-activity-box-header">
        <h3>{title}</h3>
        {onDelete && (
          <div className="moderation-icon-actions">
            <button type="button" className="moderation-icon-button" onClick={onDelete} title="Delete">
              <Icon name="TrashCan" />
            </button>
          </div>
        )}
      </div>
      {content && <div className="breadcrumb-activity-content">{content}</div>}
      <div className="breadcrumb-activity-meta">
        {meta.map(item => (
          <FormItem key={item.label} label={item.label} value={item.value} type={item.type} />
        ))}
      </div>
    </div>
  )
}

export default EventCommentActivityBox
